import { Checkbox, FormControlLabel } from "@mui/material";
import React, { memo, useCallback } from "react";

const CheckboxComponent = ({ label, disabled, checked, onChange, id }) => {
    const handleChange = useCallback(
        (e) => {
            onChange(e, id)
        },
        [onChange,id],
    )

    return <div>
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    disabled={disabled}
                    onChange={handleChange}
                />
            }
            label={`${label} `}
        />
    </div>
}

export default memo(CheckboxComponent);
